import { render, staticRenderFns } from "./stock.vue?vue&type=template&id=501bedbd&"
import script from "./stock.vue?vue&type=script&lang=js&"
export * from "./stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports